<template>
  <div v-if="isShow" id="modelCompareContainer" v-dragDiv>
    <div class="title moveDragDiv">
      版本列表
      <i class="el-icon-close" @click="close"></i>
    </div>
    <div class="content">
      <el-table :data="data" height="100%" style="width: 100%">
        <el-table-column label="" width="65" align="center">
          <template slot-scope="scope">
            <el-radio v-model="currentVersion" class="radio" :label="scope.row.version"></el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="version" label="版本号" width="100">
        </el-table-column>
        <el-table-column prop="checkInUser" label="修改人">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="operDate" label="修改日期">
        </el-table-column>
      </el-table>
    </div>
    <div class="btns">
      <el-button size="small" @click="cancel">
        退出对比
      </el-button>
      <el-button :disabled="!currentVersion" size="small" type="primary" :loading="loading" @click="startCompare">
        {{ loading ? '正在对比' : '开始对比' }}
      </el-button>
    </div>
  </div>
</template>

<script>
import modelLoaderMLib from "@/views/components/model/modelLoaderMLib";
import docService from "@/CommonDP/service/doc-service";
import { getToken, baseUrl } from "@/CommonDP/utils";
import { mapState } from "vuex";
export default {
  data() {
    return {
      isShow: false,
      data: [],
      currentVersion: "",
      loading: false,
      mlibEnabled: false
    };
  },
  computed: {
    ...mapState({
      modeldata: state => state.monge.modeldata,
    }),
  },

  methods: {
    open() {
      this.isShow = true;
      this.queryVersion();
    },

    close() {
      this.isShow = false;
    },

    async queryVersion() {
      // const json = sessionStorage.getItem("modeldata");
      const { fileId: folderID, versionID, fileObj, rvtVersion } = this.modeldata;
      if (!fileObj) {
        const res = await docService.queryBaseProperty(
          folderID,
          "0",
          versionID
        );
        if (res.result !== "0") return;
        const data = res.data || [];
        this.data = data.filter(item => item.version !== +rvtVersion);
      }
    },

    async startCompare() {
      const data = this.data.find(item => item.version === this.currentVersion);
      if (!data) return;
      const { fileId: rvtId, version: rvtVersion, status } = data;
      if (status !== "2" && status !== "6") {
        return this.$message.warning("尚未轻量化完成，无法对比");
      }
      await this.queryConvertMode(rvtId, rvtVersion);
      if (this.mlibEnabled) {
        await this.doCompareNewMode(data);
      } else {
        await this.doCompareOldMode(data);
      }
    },

    async queryConvertMode(rvtId, rvtVersion) {
      try {
        const res = await docService.queryConvertMode(rvtId, rvtVersion);
        this.mlibEnabled = res.data && res.data === 1;
      } catch (e) {
        this.mlibEnabled = false;
      }
    },

    async doCompareOldMode(data) {
      const { fileId: rvtId, version: rvtVersion } = data;
      const res = await docService.queryModelUrlList(rvtId, rvtVersion);
      if (res.result !== "0" || !res.data[0]) {
        this.$message.warning(res.message || "查询模型数据失败");
        return;
      }
      const [modelInfo] = res.data;
      if (modelInfo.fileType === 3) {
        Monge.Model.disposeCompare();
        const id = modelInfo.id;
        const url = baseUrl() + "/api/v1/doc/unzip-file/preview/" + id + "?token=" + getToken() + "&fileName=/";
        this.loading = true;
        Monge.Model.compare(url, press => {
          console.log(press);
          if (press === 1) {
            this.loading = false;
            this.$message.success("对比完成");
            this.isShow = false;
          }
        });
      }
    },

    async doCompareNewMode(data) {
      const { fileId: rvtId, version: rvtVersion } = data;
      const models = await modelLoaderMLib.queryModels(rvtId, rvtVersion);
      const {bimexName,bimexId,bimexDetailList} = models[0];
      const bimexDetailFiles = bimexDetailList.filter(ele=>ele.label == "3D" )// 
      const compareData = {bimexName, bimexId, bimexDetailList: bimexDetailFiles}
      console.log("bimexDetailFiles",compareData);
      if (!models.length) {
        this.$warning("查询模型数据失败");
        return;
      }
      Monge.Model.disposeCompare();
      this.loading = true;
      Monge.Model.compare(
        compareData,
        press => {
          console.log(press);
          if (press === 1) {
            this.loading = false;
            this.$message.success("对比完成");
            this.isShow = false;
          }
        },
        true
      );
    },

    cancel() {
      this.isShow = false;
      this.currentVersion = "";
      Monge.Model.disposeCompare();
    }
  }
};
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
#modelCompareContainer {
  position: absolute;
  width: 520px;
  height: 460px;
  top: calc(50% - 230px);
  left: calc(50% - 260px);
  background: rgba(255, 255, 255, 0.85);
  border-radius: 4px;
  z-index: 5;

  .title {
    width: 100%;
    height: 50px;
    padding: 0 15px;
    border-bottom: 1px solid #E8EBEF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 16px;
    user-select: none;
    cursor: move;

    i {
      cursor: pointer;
    }
  }

  .content {
    padding: 12px;
    box-sizing: border-box;
    height: calc(100% - 95px);

    /deep/ .el-radio__label {
      display: none;
    }
  }

  .btns {
    height: 45px;
    text-align: right;
    padding: 0 12px;
    box-sizing: border-box;
  }
}
</style>
